import { Fragment } from "react";

import type { MessageId } from "@/shared/i18n/messages";
import { useT } from "@/shared/i18n/useT";
import { MOD_KEY } from "@/shared/lib/platform";
import { Dialog } from "@/shared/ui/Dialog";
import { Kbd } from "@/shared/ui/Kbd";

const SHORTCUTS: readonly { keys: string[]; labelId: MessageId }[] = [
  { keys: [MOD_KEY, "K"], labelId: "shortcuts.palette" },
  { keys: [MOD_KEY, "B"], labelId: "shortcuts.sidebar" },
  { keys: ["/"], labelId: "shortcuts.search" },
  { keys: ["C"], labelId: "shortcuts.createHere" },
  { keys: ["G", "H"], labelId: "shortcuts.goHome" },
  { keys: ["G", "L"], labelId: "shortcuts.goLeads" },
  { keys: ["G", "U"], labelId: "shortcuts.goUnits" },
  { keys: ["G", "P"], labelId: "shortcuts.goPipeline" },
  { keys: ["G", "R"], labelId: "shortcuts.goRequests" },
  { keys: ["G", "C"], labelId: "shortcuts.goCalendar" },
  { keys: ["?"], labelId: "shortcuts.help" },
  { keys: ["Esc"], labelId: "shortcuts.close" },
];

export function ShortcutsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const t = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={t("shell.shortcuts")}>
      <dl className="grid grid-cols-[1fr_auto] gap-x-6 gap-y-3 text-[14px]">
        {SHORTCUTS.map(({ keys, labelId }) => (
          <Fragment key={labelId}>
            <dt className="text-ink-muted">{t(labelId)}</dt>
            <dd dir="ltr" className="flex items-center justify-end gap-1">
              {keys.map((key, index) => (
                <Fragment key={key}>
                  {index > 0 && keys[0] === "G" ? (
                    <span className="text-[12px] text-ink-faint">{t("shortcuts.then")}</span>
                  ) : null}
                  <Kbd>{key}</Kbd>
                </Fragment>
              ))}
            </dd>
          </Fragment>
        ))}
      </dl>
    </Dialog>
  );
}
